import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from '../../../theme';

export const StyledCard = styled.a`
  min-height: 13.75rem;
  text-align: left;
  background-color: ${color('white')};
  border-radius: ${radius('md')};
  box-shadow: ${shadow('md')};
  color: inherit;

  cursor: pointer;
  transition: 0.3s;

  @media (min-width: ${screen('md')}) {
    display: flex;
  }

  &:hover {
    box-shadow: ${shadow('card')};
    color: inherit;
  }
`;

export const StyledThumb = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${radius('md')} ${radius('md')} 0 0;
  overflow: hidden;
  height: 14rem;

  @media (min-width: ${screen('md')}) {
    width: 12.5rem;
    height: auto;
    border-radius: ${radius('md')} 0 0 ${radius('md')};
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const StyledEmptyThumb = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing('xl')};
  height: 100%;
  width: 100%;
  background-image: linear-gradient(
    47deg,
    ${color('purple_700')},
    ${color('mint_900')} 70%
  );

  img {
    height: auto;
  }
`;

export const StyledContent = styled.div`
  padding: ${spacing('lg')};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledDate = styled.p`
  font-weight: ${fontWeight('bold')};
  color: ${color('text_subtle')};
  font-size: ${fontSize('sm')};
  line-height: 1;
  text-transform: uppercase;
  margin: 0;
`;

export const StyledTitle = styled.h2`
  font-weight: ${fontWeight('medium')};
  font-size: ${fontSize('xl')};
  margin-bottom: ${spacing('md')};
  margin-top: 0;
`;

export const StyledExcerpt = styled.div`
  color: ${color('text_subtle')};

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
